var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherDashboardMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 144,
    viewBox: "0 0 343 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1590_178821)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 144,
    rx: 16,
    fill: "#FDF4C0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 25.5,
    r: 54.5,
    fill: "#FEE440"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 72,
    r: 55,
    fill: "#FEE440"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 132,
    r: 4,
    fill: "#FEE440"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 14,
    r: 4,
    fill: "#FEE440"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1590_178821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 144,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDashboardMobile);
export default __webpack_public_path__ + "static/media/teacher-dashboard-mobile.614d04a6c07a1d6a3ac343a32d1968fd.svg";
export { ForwardRef as ReactComponent };